<template>
	<div
		:id="id"
		class="ie-focusable"
		role="tabpanel"
		tabindex="0"
		:aria-labelledby="labelledBy"
		v-show="active"
	>
		<slot />
	</div>
</template>

<script>
export default {
	name: "TabViewPanel",

	props: {
		id: {
			type: String,
			required: true
		},

		labelledBy: {
			type: String,
			required: true
		},

		active: {
			type: Boolean,
			required: true
		}
	}
};
</script>
